'use strict';
import $ from 'jquery';
import Swiper from 'swiper';

$(document).ready(function () {
    $('.blog__single-filter-input').on('change', () => {
        setUrl();
    });

    $('.stories__slider-holder').each(function () {
        const slider = new Swiper(this, { // eslint-disable-line no-unused-vars
            loop: false,
            slidesPerView: 3,
            spaceBetween: 9,
            centeredSlides: true
        });
    });
});

function setUrl () {
    let query = '';

    $('.blog__single-filter-input:checked').each(function (idx) {
        if (idx !== 0) {
            query += '+' + $(this).val();
        } else {
            query += $(this).val();
        }
    });

    if (query !== '') query = 'tagged/' + query;

    const location = window.location.pathname.split('/');

    window.location.href = location[0] + '/' + location[1] + '/' + location[2] + '/' + query;
}
